import React from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useLocation } from "react-router-dom";
import Modal from "react-modal";

const PageOut = () => {
  const { oktaAuth } = useOktaAuth();
  const location = useLocation();
  const message = location.state?.message;
  const logout = async () => oktaAuth.signOut("/");

  const clearStorage = () => {
    localStorage.setItem("accessToken", null);
    localStorage.setItem("role", null);
    localStorage.setItem("subscription", null);
    localStorage.setItem("user_id", null);
    localStorage.setItem("country", null);
    localStorage.setItem("locality", null);
    localStorage.setItem("region", null);
    localStorage.setItem("timezone", null);
    localStorage.setItem("country_id", null);
    localStorage.setItem("state_id", null);
    localStorage.setItem("isAuthenticated", false);
  };

  return (
    <React.Fragment>
      <Modal
        isOpen={true}
        // onRequestClose={CloseModal}
        className="usermodal-pageout"
        contentLabel="Modal"
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            overflowY: "auto",
            maxWidth: "500px"
            //   border:"none"
          },
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 1000
          }
        }}
      >
        <section className="error-page">
          <div className="container">
            <div className="not-found py-4">
              {message &&
                message
                  .split(".")
                  .filter(Boolean)
                  .map((sentence, index) => (
                    <p
                      style={{
                        fontSize: "16px",
                        textAlign: "center",
                        color: "#18274A"
                      }}
                      key={index}
                    >
                      {sentence.trim()}.
                    </p>
                  ))}
              <div className="save-cancel">
                <div className="resetnew-update">
                  <button
                    onClick={() => {
                      logout();
                      clearStorage();
                    }}
                    type="button"
                  >
                    Logout
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      </Modal>
    </React.Fragment>
  );
};

export default PageOut;
